<template>
  <div>
    <div v-if="queueLoading">
      {{ $t("blur_queue.queue_table.loading") }}
    </div>
    <div v-else>
      <div v-if="queueItems.length === 0">
        {{ $t("blur_queue.queue_table.no_data") }}
      </div>
      <div v-else>
        <b>{{ $t("blur_queue.queue_table.title") }}</b>

        <table
          class="table-fixed w-full border-solid px-4 mt-3 data-table-right-section overflow-y-auto table-parent"
        >
          <thead>
            <tr>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("blur_queue.queue_table.headers.retailer_code") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("blur_queue.queue_table.headers.retailer") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("blur_queue.queue_table.headers.created_at") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("blur_queue.queue_table.headers.last_updated_at") }}
              </th>
              <th class="w-3/12 px-2 pb-2 text-left font-semibold">
                {{ $t("blur_queue.queue_table.headers.blur_status") }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(queueItem, index) in queueItems"
              :key="index"
              v-bind:class="[
                'hover:bg-gray-50',
                index === queueItems.length - 1 ? '' : 'border-b'
              ]"
            >
              <td class="py-3 px-2 text-left text-sm">
                {{ queueItem.retailer_code }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ queueItem.retailer_name }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ formatDate(queueItem.created_at) }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{ formatDate(queueItem.last_updated_at) }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                {{
                  $t(
                    `general.status.blur.${queueItem.bodyprint.blur_status.toLowerCase()}`
                  )
                }}
              </td>
              <td class="py-3 px-2 text-left text-sm">
                <dots-dropdown>
                  <div
                    v-if="!editBlurDisabled(queueItem)"
                    class="dropdown-item"
                    @click="handleBlur(queueItem)"
                  >
                    {{ $t("blur_queue.queue_table.buttons.edit_blur") }}
                  </div>
                  <div v-else class="dropdown-item">
                    {{
                      $t("blur_queue.queue_table.buttons.no_action_available")
                    }}
                  </div>
                </dots-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DotsDropdown from "@/components/general/dots-dropdown.vue";
import { BodyprintQueueStatus } from "@/enums/modules/BodyprintQueueStatus";
import { BlurQueueStatus } from "@/enums/modules/BlurQueueStatus";

export default {
  name: "BodyprintBlurQueueTable",
  components: { DotsDropdown },
  props: {
    queueItems: {
      type: Array,
      default: () => []
    },
    queueLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    editBlurDisabled(queueItem) {
      return (
        queueItem.status === BodyprintQueueStatus.IN_REVIEW &&
        queueItem.bodyprint.blur_status === BlurQueueStatus.REJECTED
      );
    },
    handleBlur(queueItem) {
      this.$emit("handle-blur", queueItem);
    },
    formatDate(date) {
      return moment(date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY");
    }
  }
};
</script>
